import * as Yup from 'yup'
import { NAME } from '../../forms/Multiplatform/LineItemForms/fields'

const nameValidation = {
  [NAME]: Yup.string().max(400, 'Name should have maximum 400 characters').required('Name Required')
}

export default nameValidation
